<template>
  <section class="ajustes">
    <div class="opcoes">
      <h3>Personalização das telas</h3>
      <button v-for="(opcao, index) in opcoes" :key="index" :class="{ ativo: storeEditar.telaSelecionada === opcao.tela }" @click="selecionarTela(opcao.tela)">
        <Svgs :nome="opcao.icone" />
        <span>{{ opcao.nome }}</span>
      </button>
    </div>
    <AjustesLogin v-if="storeEditar.telaSelecionada === 'telaLogin'" />
    <AjustesLoading v-if="storeEditar.telaSelecionada === 'telaLoading'" />
    <AjustesCursos v-if="storeEditar.telaSelecionada === 'telaCursosArea'" />
    <AjustesCurso v-if="storeEditar.telaSelecionada === 'telaCurso'" />
    <AjustesModulo v-if="storeEditar.telaSelecionada === 'telaModulo'" />
    <AjustesAula v-if="storeEditar.telaSelecionada === 'telaAula'" />
    <AjustesPerfil v-if="storeEditar.telaSelecionada === 'telaPerfil'" />
    <AjustesMenu v-if="storeEditar.telaSelecionada === 'menu'" />
  </section>
</template>

<script setup>
import { reactive } from 'vue'
import { useStoreEditar } from '@stores'
import Svgs from '@svgs'

import AjustesLogin from '@/components/editar/personalizar/ajustes/Login.vue'
import AjustesLoading from '@/components/editar/personalizar/ajustes/Loading.vue'
import AjustesCursos from '@/components/editar/personalizar/ajustes/Cursos.vue'
import AjustesCurso from '@/components/editar/personalizar/ajustes/Curso.vue'
import AjustesModulo from '@/components/editar/personalizar/ajustes/Modulo.vue'
import AjustesAula from '@/components/editar/personalizar/ajustes/Aula.vue'
import AjustesPerfil from '@/components/editar/personalizar/ajustes/Perfil.vue'
import AjustesMenu from '@/components/editar/personalizar/ajustes/Menu.vue'

const storeEditar = useStoreEditar()

const opcoes = reactive([
  { nome: 'Login', icone: 'envelope', tela: 'telaLogin' },
  { nome: 'Loading', icone: 'loading', tela: 'telaLoading' },
  { nome: 'Início', icone: 'casa', tela: 'telaCursosArea' },
  { nome: 'Curso', icone: 'curso', tela: 'telaCurso' },
  { nome: 'Módulo', icone: 'modulo', tela: 'telaModulo' },
  { nome: 'Aula', icone: 'play', tela: 'telaAula' },
  { nome: 'Perfil', icone: 'usuario', tela: 'telaPerfil' },
  { nome: 'Menu', icone: 'menu', tela: 'menu' }
])

function selecionarTela(tela) {
  storeEditar.telaSelecionada = tela
}
</script>

<style scoped>
section.ajustes {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: fixed;
  top: 60px;
  right: 0;
  width: 320px;
  height: calc(100dvh - 60px);
  background-color: var(--cor-escuro-2);
  border-left: 2px solid var(--cor-escuro-3);
  overflow-y: scroll;
  scrollbar-width: none;
  z-index: 2;
}
section.ajustes::-webkit-scrollbar {
  display: none;
}
.vazio {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: var(--cor-escuro-2);
  position: absolute;
  animation: fadeIn 0.3s linear;
}
.vazio svg {
  width: 100px;
}
.vazio p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  line-height: 1.5;
  text-align: center;
  width: 100%;
  max-width: 200px;
  margin: 10px 0 0 0;
}
.opcoes {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--cor-escuro-2);
  width: 100%;
  padding: 15px 15px 5px 15px;
  z-index: 4;
}
.opcoes h3 {
  font-family: var(--bold);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  margin: 0 0 10px 0;
  width: 100%;
}
.opcoes button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--cor-escuro-3);
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
  width: calc(25% - 5px);
  padding: 10px 0;
  border-radius: 10px;
  margin: 0 0 10px 0;
  transition: all 0.3s;
}
.opcoes button.ativo {
  background-color: var(--cor-marca);
  color: var(--cor-branco-fixo);
  pointer-events: none;
}
.opcoes button.ativo svg {
  fill: var(--cor-branco-fixo);
}
.opcoes button:hover {
  background-color: var(--cor-escuro-4);
}
.opcoes button svg {
  width: 13px;
  min-width: 13px;
  max-height: 13px;
  fill: var(--cor-escuro-5);
  margin: 0 0 8px 0;
  transition: all 0.3s;
}
section.ajustes {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
section.ajustes input,
section.ajustes textarea,
section.ajustes [contenteditable='true'] {
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}
/* Responsivo */
@media screen and (max-width: 1000px) {
  section.ajustes {
    top: auto;
    bottom: 0;
    right: 0px;
    width: 100%;
    height: 45dvh;
  }
}
</style>
